import { useState } from 'react'
import { Heart } from 'lucide-react'
import DonationModal from './DonationModal'

const DonateButton = ({ className = '' }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        aria-label="Support IqraWave"
        title="Support IqraWave"
        className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg border border-rose-200 text-rose-600 bg-rose-50/60 hover:bg-rose-100 hover:border-rose-300 transition-colors ${className}`}
      >
        <Heart className="w-4 h-4 fill-rose-500 shrink-0" />
        <span>Help us grow</span>
      </button>

      <DonationModal isOpen={open} onClose={() => setOpen(false)} />
    </>
  )
}

export default DonateButton
